import React, { useEffect, useState } from "react";
import { FaRegArrowAltCircleLeft } from "react-icons/fa";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  addData,
  getData,
  updateData,
} from "../services/axios.function";
import UpdateButton from "../components/UpdateButton";

const Playlist = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const isEdit = !!editData;

  const [festivalList, setFestivalList] = useState([]);

  const [formData, setFormData] = useState({
    sortOrder: "",
    playlistId: "",
    isActive: true,
  });

  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  /* ===============================
   Fetch Festival Dropdown Data
=============================== */
  const fetchFestivals = async () => {
    try {
      const res = await getData("api/festival/get-all");
      if (res?.data?.isSuccess) {
        setFestivalList(res.data.data || []);
      }
    } catch (err) {
      toast.error("Failed to load festival list");
    }
  };

  useEffect(() => {
    fetchFestivals();

    const fetchLastSortOrder = async () => {
      try {
        const res = await getData("api/playlist/get-last-sr-no");
        if (res?.data?.isSuccess) {
          const lastNo = res.data.data?.sortOrder || 0;
          setFormData((prev) => ({ ...prev, sortOrder: lastNo + 1 }));
        }
      } catch (err) {
        toast.error("Failed to fetch sort order");
      }
    };

    if (!isEdit) {
      fetchLastSortOrder();
    } else {
      setFormData({
        sortOrder: editData.sortOrder,
        playlistId: editData.playlistId || "",
        type: editData.type?._id || "",
        isActive: editData.isActive,
      });
    }
  }, [isEdit, editData]);

  const validateForm = () => {
    const newError = {};

    if (!formData.playlistId.trim()) newError.playlistId = "Playlist is required";
    if (!formData.type) newError.type = "Festival type is required";

    setError(newError);
    return Object.keys(newError).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setError((prev) => ({ ...prev, [name]: "" }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      const payload = {
        sortOrder: Number(formData.sortOrder),
        playlistId: formData.playlistId,
        type: formData.type,
        isActive: formData.isActive,
      };

      let res;
      if (isEdit) {
        res = await updateData("api/playlist/update", {
          ...payload,
          _id: editData._id,
        });
      } else {
        res = await addData("api/playlist/add", payload);
      }

      if (res?.data?.isSuccess) {
        toast.success(res.data.message);
        navigate("/playlists");
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err.message || "Something went wrong!"
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="container-fluid">
      <div className="mb-4">
        <h4>{isEdit ? "Edit Playlist" : "Add Playlist"}</h4>
      </div>

      <form className="add-edit-form" onSubmit={handleSubmit}>
        <div className="row">
          {/* Sort Order */}
          <div className="col-lg-4 mb-3">
            <label>Sort Order No:</label>
            <input
              type="text"
              name="sortOrder"
              value={formData.sortOrder}
              className="custom-ip"
              readOnly
            />
          </div>

          {/* Festival Type */}
          <div className="col-lg-4 mb-3">
            <label>Festival Type:</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className={`custom-ip ${error.type ? "is-invalid" : ""}`}
            >
              <option value="">Select Festival Type</option>
              {festivalList.map((festival) => (
                <option key={festival._id} value={festival._id}>
                  {festival.name}
                </option>
              ))}
            </select>
            {error.type && (
              <div className="invalid-feedback">{error.type}</div>
            )}
          </div>

          {/* isActive */}
          <div className="col-lg-4 mb-3">
            <label>Active Status</label>
            <div className="mt-2">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                />
                <span className="slider" />
              </label>
            </div>
          </div>

          {/* Playlist Id */}
          <div className="col-lg-12 mb-3">
            <label>Playlist Id:</label>
            <textarea
              name="playlistId"
              rows="4"
              placeholder="Enter playlist id"
              value={formData.playlistId}
              onChange={handleChange}
              className={`custom-ip ${error.playlistId ? "is-invalid" : ""}`}
            />
            {error.playlistId && (
              <div className="invalid-feedback">{error.playlistId}</div>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-center align-items-center gap-4">
          <div className="cancel-btn my-3">
            <Link to="/playlists">
              <button type="button">
                <FaRegArrowAltCircleLeft size={22} />
                Cancel
              </button>
            </Link>
          </div>

          <div className="submit-btn my-3">
            <UpdateButton loading={loading} isEdit={isEdit} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Playlist;
